<template>
    <div>
        <hr>
        <b-row>
            <b-col cols="12">
                <!--<div v-if="selected_sop_assignment == -1" class="d-inline-flex">
                    <div class="workflow-tile m-1 p-1" v-for="item in assignment_items" :key="item.id" @click="selected_sop_assignment = item.id">
                        <p>{{item.name}}</p>
                        <p class="text-truncate">
                            {{item.description}}
                        </p>
                    </div>
                </div>-->
                <!--<div v-else class="d-inline-flex">
                    <b-button @click="selected_sop_assignment = -1" class="me-2">
                        <i class="fas fa-arrow-left"></i>
                    </b-button>
                    <span class="card-title pt-2">{{selected_assignment_item.name}}</span>
                </div>-->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-tabs ref="sopAssignmentTabs" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                    <b-tab lazy active>
                        <template v-slot:title>
                            <span class="d-none d-sm-inline-block">Assigned Documents / Groups</span>
                        </template>

                        <div>
                            <div>
                                <span style="float: right;" class="pb-1">
                                    <span class="mt-0 pt-0">
                                        <!--<b-button @click="show_add_type = 'group'" size="sm" class="me-2">Manage Groups</b-button>-->
                                        <b-button @click="show_add_type = 'document'" size="sm" :disabled="selected_organogram_level == null">Manage Documents</b-button>
                                    </span>
                                </span>
                                <strong class="pt-1">SOP Workflow for Level:</strong><span class="ms-2 text-primary">{{getSelectedLevelName}}</span>
                            </div>
                            
                            <!--<div class="d-inline-flex" v-if="selected_organogram_level != null">
                                <div class="me-1 text-center"
                                v-for="(workflow, idx) in workflows" :key="idx"
                                style="border: 1px solid black;width: 10rem; height: 6rem;">
                                    <div class="font-size-13 text-dark">{{capitalizeFirstLetter(workflow.sop_name)}}</div>
                                    <span class="font-size-11 text-muted">{{workflow.sop_group_name}}</span>
                                </div>
                            </div>-->
                            <span style="display: inline-flex; flex-wrap: wrap;" v-if="selected_organogram_level != null">
                                <div
                                :title="doc.name"
                                :id="'doc'+doc.id"
                                class="document-tile"
                                v-for="(doc, idx) in workflows" :key="idx">
                                    <SopCard :name="doc.sop_name" :code="doc.sop_code" />
                                </div>
                            </span>
                            <b-alert :show="workflows.length == 0"> No workflows</b-alert>
                            <b-alert class="mt-3" :show="selected_organogram_level == null"> No Level Selected</b-alert>
                        </div>

                        
                    </b-tab>
                    <b-tab lazy>
                        <template v-slot:title>
                            <span class="d-none d-sm-inline-block">Organogram</span>
                        </template>
                        <LevelsOrgChart @level_id="setID"/>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
        <b-modal id="assignmentModal" :title="getModalTitle" v-if="show_assignment_modal == true" @hidden="show_assignment_modal = false" size="lg" >
            <div slot="modal-footer">
                <div clas="d-flex">
                    <b-button @click="saveAssignedDocuments()" class="ms-auto" variant="success">Save</b-button>
                </div>
            </div>
            <!-- if GROUP is selected -->
            <b-overlay :show="is_saving">
            <div v-if="show_add_type == 'group'" style="max-height: 80vh; ">
                <b-overlay>
                    <div class="text-primary">Select SOP Groups</div>
                    <div v-for="group in sop_groups" :key="group.id">
                        <input type="checkbox" :id="`input${group.id}`" :value="group.id" v-model="checked_items">
                        <label :for="`input${group.id}`">{{group.name}}</label>
                    </div>
                </b-overlay>
            </div>
            <div v-if="show_add_type == 'document'" style="max-height: 80vh; ">
                <div v-for="group in available_sop_groups" :key="group.id"><!--  -->
                    <div @click="selected_collapse = group.id" class="sop-group-list">
                        - {{group.name}}
                    </div>
                    <b-collapse :id="String(group.id)" :visible="selected_collapse == group.id" :accordion="String(group.id)" role="tabpanel" class="sop-group-items">
                        <div v-for="sop in group.sop_types" :key="sop.id" class="sop-group-item">
                            <ChecklistItem
                            @clickedItem="handleChecklistClick"
                            :enabled="isInChecklistArray(sop.id)"
                            :item_id="sop.id"
                            :text="sop.name"/>
                        </div>
                        <div class="d-flex">
                            <b-button @click="selectAllForGroup(group.id)" variant="primary" class="ms-auto tiny-button" size="sm">Select All</b-button>
                            <b-button @click="removeAllForGroup(group.id)" variant="danger" class="tiny-button" size="sm">Remove All</b-button>
                        </div>
                    </b-collapse>
                </div>
            </div>
            
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import ChecklistItem from './components/checklist-item.vue'
import _ from 'lodash'
import { clientAdminState, sopClientAdminState, sopClientAdminMethods } from '@/state/helpers'
import LevelsOrgChart from './components/levelOrgChart.vue';
import SopCard from '@/components/widgets/misc/sopCard.vue'
export default {
    components:{
        ChecklistItem,
        LevelsOrgChart,
        SopCard
    },
    watch:{
        selected_organogram_level(newValue){
            if(newValue != null){
                this.loadWorkflowsForLevel(newValue);
            }
        },
        show_add_type(newValue){
            if(newValue != false){
                this.setCheckedItems();
                this.show_assignment_modal = true;
                this.$nextTick(()=>{
                    this.$bvModal.show('assignmentModal')
                    this.$root.$once('bv::modal::hidden',(event)=>{
                        if(event.type == 'hidden' && event.componentId == 'assignmentModal'){
                            this.show_assignment_modal = false;
                            this.show_add_type = false;
                        }
                    })
                })
            }
        },
        checked_items(newValue, oldValue){
            console.log(newValue, oldValue)
        }

    },
    data:() => ({
        is_saving: false,
        is_loading_workflows: false,
        selected_organogram_level: null,
        selected_sop_assignment: -1,
        assigned_documents_list:[
            
        ],
        selected_assignment_item: null,

        //config vars
        show_add_type: false,
        show_assignment_modal: false,
        available_sop_groups:[],
        selected_collapse: -1,
        checked_items: [],
    }),
    computed:{
        ...sopClientAdminState,
        ...clientAdminState,
        getSelectedLevelName(){
            if(this.selected_organogram_level != null){
                let level = this.user_levels.find( level => {
                    return level.id == this.selected_organogram_level;
                })
                if(level){
                    return level.name;
                }
            }
            return 'No level selected'
        },
        getModalTitle(){
            switch(this.show_add_type){
                case 'group':{
                    return 'SOP Groups';
                }
                case 'document':{
                    return 'Individual SOP';
                }
                default:{
                    return ''
                }
            }
        },
        processes_sop_groups(){
            let loop_data = _.cloneDeep(this.sop_groups)
            loop_data.forEach( group => {
                group['selected'] = true;
            });
            return loop_data;
        }
    },
    methods:{
        ...sopClientAdminMethods,
        loadWorkflowsForLevel(level_id){
            return new Promise((resolve, reject) => {
                this.is_loading_workflows = true;
                this.loadWorkflows(level_id)
                .then(()=>{
                    this.is_loading_workflows = false;
                    resolve();
                })
                .catch(()=>{
                    reject();
                })
            })
            
        },
        setID(id){
            this.checked_items = [];
            this.selected_organogram_level = Number(id);
            this.$refs.sopAssignmentTabs.previousTab()
        },
        updateAssignedList(){
            let params = {
                level_id: this.selected_organogram_level,
                sop_group_id: 29,
                sog_type_id: -1
            }
            this.assignSopToWorkflow(params).then(()=>{
                this.loadWorkflowsForLevel(this.selected_organogram_level);
            })
        },
        // fire assign endpoint
        assignItem(id){
            this.is_saving = true;
            let params = {
                level_id: this.selected_organogram_level,
                sop_group_id: this.show_add_type == 'group' ? id : -1,
                sop_type_id: this.show_add_type == 'document' ? id : -1,
            }
            this.assignSopToWorkflow(params).then(()=>{
                this.loadWorkflowsForLevel(this.selected_organogram_level).then(()=>{
                    this.setCheckedItems();
                    this.is_saving = false;
                })
            })
        },
        // fire unassign endpoint
        unassignItem(id){
            this.is_saving = true;
            let params = {
                level_id: this.selected_organogram_level,
                sop_group_id: this.show_add_type == 'group' ? id : -1,
                sop_type_id: this.show_add_type == 'document' ? id : -1,
            }
            this.unassignSopToWorkflow(params).then(()=>{
                this.loadWorkflowsForLevel(this.selected_organogram_level).then(()=>{
                    this.setCheckedItems();
                    this.is_saving = false;
                })
            })
        },
        isInChecklistArray(id){
            return this.checked_items.includes(id);
        },
        handleChecklistClick(id){
            if(this.isInChecklistArray(id)){
                let index = this.checked_items.findIndex( item => {
                    return id == Number(item);
                })
                this.checked_items.splice(index, 1);
            }
            else{
                this.checked_items.push(id);
                //this.assignItem(id);
            }
        },
        setCheckedItems(){
            this.checked_items = [];
            this.workflows.forEach( e => {
                this.checked_items.push(e.sop_id)
            })
        },
        selectAllForGroup(group_id){
            let group = this.available_sop_groups.find( group => { return group.id == group_id});
            if(group){
                group.sop_types.forEach( sop => {
                    if(this.checked_items.includes(sop.id) == false){
                        this.checked_items.push(sop.id);
                    }
                })
            }
        },
        removeAllForGroup(group_id){
            let group = this.available_sop_groups.find( group => { return group.id == group_id});
            if(group){
                group.sop_types.forEach( sop => {
                    let sop_index = this.checked_items.findIndex( item => { return item == sop.id});
                    if(sop_index != -1){
                        this.checked_items.splice(sop_index, 1);
                    }
                })
            }
        },
        saveAssignedDocuments(){
            this.is_saving = true;
            let params = {
                level_id: this.selected_organogram_level,
                sop_assignments:[]
            }
            this.checked_items.forEach( item_id => {
                let param = {
                    sop_type_id: this.show_add_type == 'document' ? item_id : -1,
                    sop_group_id: this.show_add_type == 'group' ? item_id : -1,
                }
                params.sop_assignments.push(param);
            });
            
            this.assignSopToWorkflow(params).then(()=>{
                this.loadWorkflowsForLevel(this.selected_organogram_level).then(()=>{
                    this.setCheckedItems();
                    this.is_saving = false;
                    this.$bvModal.hide('assignmentModal');
                    this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Documents saved.', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 3000, timerProgressBar: true});
                })
            })
        },

        capitalizeFirstLetter(string){
            let lowercase = string.toLowerCase();
            return lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
        }
    },
    mounted(){
        this.clearSopsFromGroup();

        if(this.selected_organogram_level == null){
            this.$nextTick(()=>{
                this.$refs.sopAssignmentTabs.nextTab();
            })
        }
        this.loadSopGroups()
        .then(()=>{
            this.loadAssignableSops(-1)
            .then(()=>{
                this.available_sop_groups = _.cloneDeep(this.assignable_sops);
                this.available_sop_groups.forEach( group => {
                    group['selected'] = false;
                });
            })
        })
    },
    beforeDestroy(){
        this.clearSopsFromGroup();
    }
}
</script>

<style>
.unassign-sop-icon{
    position: absolute;
}
.workflow-tile{
    cursor: pointer;
    text-align: center;
    width: 9rem;
    height: 4.5rem;
    border: 1px rgb(209, 209, 209) solid;
    border-radius: 0.25rem;
}
.sop-group-list{
    cursor: pointer;
}
.sop-group-list:hover{
    color: blue;
    background: rgb(226, 226, 226)
}
.sop-group-items{
    padding-left: 0.3rem;
    border-left: 1px solid grey;
    border-right: 1px solid grey;
    border-bottom: 1px solid grey;
}
.sop-group-item{
    cursor: pointer;
}
.sop-group-item:hover{
    text-decoration: underline;
}

.tiny-button{
    padding: 0;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    margin-bottom: 0.25rem;
    margin-right: 0.25rem;
}
</style>